import { createSelector } from '@reduxjs/toolkit';
import { selectUserDisplayNames, selectIsLoadingUserNames } from './Redux/activitySelectors';

export type NameCellState =
  | { kind: 'dash' }
  | { kind: 'loading' }
  | { kind: 'resolved'; name: string };

export const makeSelectNameCellState = (userId: string | null) =>
  createSelector(
    selectUserDisplayNames,
    selectIsLoadingUserNames,
    (names, isLoading): NameCellState => {
      if (!userId)                         return { kind: 'dash' };
      if (isLoading && !(userId in names)) return { kind: 'loading' };
      const name = names[userId] ?? '';
      return name ? { kind: 'resolved', name } : { kind: 'dash' };
    }
  );
